module.exports = __webpack_public_path__ + "src/assets/textures/env/barn/wooden_frame_1k_bake.png";